module.exports = __webpack_public_path__ + "img/04-B12.3a4a4923.png";